import React from 'react'

import BiddingContractSubstep from './BiddingContractSubstep'
import Form from "../../components/form/Form";
import Project from "../../models/Project";

export default class BiddingContractContactDetailsSubstep extends BiddingContractSubstep {
    static SubstepName = 'Add Additional Info';

    static TranslationKey = '';

    static SubstepSlug = 'add-additional-info';
    static path = '/add-additional-info';


    static StepTitle = 'Project Coordinator';
    static StepInfo = 'Please fill in the following details to finalize the Statement of Work';

    static hasCompletedForProject(project) {
        return project.client_contact_name?.length
            && project.client_contact_email?.length
    }

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        let model = TB.pick(props.project, ['client_contact_name', 'client_contact_email']);

        this.state = {
            ...this.state,
            model
        }
    }

    formFields() {
        return [{
            fields: {
                client_contact_label: (
                    <p className="sow-approval-question-label">
                        Who is the <b>project coordinator</b> that will serve as the single point of contact for this
                        project?
                    </p>
                )
            }
        }, {
            style: {flexDirection: 'row', margin: '0 -15px'},
            fields: {
                client_contact_name: {
                    type: 'text',
                    maxLength: 110,
                    label: "Contact Name",
                    required: true,
                    columns: 6,
                    style: {
                        padding: '0 15px',
                    },
                    placeholder: 'Add contact name'
                },
                client_contact_email: {
                    type: 'email',
                    style: {
                        padding: '0 15px',
                    },
                    max: 110,
                    label: "Contact Email",
                    required: true,
                    columns: 6,
                    placeholder: 'Add contact email'
                }
            }
        },
        ]
    }

    renderStepContent() {
        let {project, forReview, canEditSOWForProject} = this.props;
        if (!project) {
            return <div/>
        }

        if (forReview) {
            return (
                <div className="row items-center sow-approval-details-step">
                    <div className="md:w-4/12 flex flex-col text-left">
                        <label>Client Contact</label>
                        <p>Name: {project.client_contact_name || 'N/A'}</p>
                        <p>Email: {project.client_contact_email || 'N/A'}</p>
                    </div>
                </div>
            )
        }

        return (
            <Form
                ref={this.formRef}
                submitButton={false}
                cancelButton={false}
                isDisabled={this.props.isDisabled || this.props.isLocked || !canEditSOWForProject}
                className="sow-approval-details-form"
                fields={this.formFields()}
                model={this.state.model}
                onSubmit={async (model) => {
                    let response = await this.props.makeRequest(
                        () => this.props.project.update({...model}),
                        Project.SyncRequest
                    );

                    if (response) {
                        return this.props.approveStep();
                    }
                }}
                onChange={model => {
                    this.setState({model})
                }}
            >

                <div className="mt-5">
                    <button
                        type="button"
                        onClick={() => {
                            if (!canEditSOWForProject) {
                                return TB.showPermissionError();
                            }
                            if (this.formRef.current.forceValidate()) {
                                return;
                            }
                            return this.formRef.current.onSubmit(this.state.model)
                        }}
                        className={TB.mapClass('btn btn-primary approve-btn', {'disabled-edit-link': !canEditSOWForProject})}
                        disabled={this.props.isDisabled || this.props.isLocked}>
                        Save & Continue
                        {!canEditSOWForProject && (<i className="fa fa-lock ml-1"/>)}
                    </button>
                </div>

            </Form>
        );
    }
}